<script setup lang="ts">
import Button from 'primevue/button';

const { expanded } = defineProps<{
  expanded?: boolean;
}>();

const emit = defineEmits<{
  prev: [];
  next: [];
}>();
</script>

<template>
  <div class="iban-swiper-controls" :class="{ expanded: expanded }">
    <Button
      aria-label="Previous IBAN"
      icon="pi pi-angle-left"
      type="button"
      severity="secondary"
      rounded
      variant="outlined"
      @click="emit('prev')"
    />
    <Button
      aria-label="Next IBAN"
      icon="pi pi-angle-right"
      type="button"
      severity="secondary"
      rounded
      variant="outlined"
      @click="emit('next')"
    />
  </div>
</template>

<style scoped lang="scss">
.iban-swiper-controls {
  display: flex;
  flex-direction: row;
  gap: 0.25rem;

  &.expanded {
    flex-direction: column;
  }

  :deep(.p-button) {
    width: 2.375rem; // 38px
    height: 2.375rem; // 38px
    padding: 0;
  }

  :deep(.p-button-icon) {
    font-size: $static-text-sm;
  }
}
</style>
